module.exports = __webpack_public_path__ + "img/5.88.0cfe7b0e.png";